(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const configElement = document.querySelector('.mobile-conversion-config');

  if (!configElement) return;

  const messages = configElement.dataset;

  const buildAssurance = (className, itemClassName) => {
    const wrapper = document.createElement('div');
    wrapper.className = className;
    wrapper.setAttribute('role', 'list');

    [messages.delivery, messages.dispatch, messages.returns, messages.duties].forEach((message) => {
      if (!message) return;
      const item = document.createElement('span');
      item.className = itemClassName;
      item.setAttribute('role', 'listitem');
      item.textContent = message;
      wrapper.append(item);
    });

    return wrapper;
  };

  const initCollectionDescription = () => {
    if (!document.body.classList.contains('template-collection')) return;

    const description = document.querySelector('.collection-hero__description');
    if (!description || description.dataset.mobileEnhanced === 'true') return;

    description.dataset.mobileEnhanced = 'true';
    description.classList.add('mobile-description-collapsed');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'mobile-collection-description-toggle';
    toggle.textContent = messages.readMore;
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.textContent = expanded ? messages.readMore : messages.readLess;
      description.classList.toggle('mobile-description-collapsed', expanded);
    });

    description.insertAdjacentElement('afterend', toggle);
  };

  const initMobileSearch = () => {
    const search = document.querySelector('.header__search');
    if (!search || search.dataset.mobileEnhanced === 'true') return;

    const form = search.querySelector('.search-modal__form');
    const input = search.querySelector('input[type="search"], input[role="combobox"]');
    if (!form || !input) return;

    search.dataset.mobileEnhanced = 'true';
    search.classList.add('mobile-search-ready');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'mobile-search-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', messages.openSearch);
    toggle.textContent = '⌕';
    search.prepend(toggle);

    const closeSearch = () => {
      search.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', messages.openSearch);
    };

    toggle.addEventListener('click', () => {
      const opening = !search.classList.contains('is-open');
      search.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', String(opening));
      toggle.setAttribute('aria-label', opening ? messages.closeSearch : messages.openSearch);
      if (opening) {
        const header = document.querySelector('header');
        search.style.setProperty('--mobile-search-top', `${Math.ceil(header?.getBoundingClientRect().bottom || 70)}px`);
        input.focus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearch();
    });

    document.addEventListener('click', (event) => {
      if (!search.contains(event.target)) closeSearch();
    });
  };

  const initProductJourney = () => {
    if (!document.body.classList.contains('template-product')) return;

    const originalButton = document.querySelector('.product-form__submit');
    const buttonsContainer = document.querySelector('.product-form__buttons');
    const price = document.querySelector('.price--product');
    if (!originalButton || !buttonsContainer || !price) return;

    document.querySelectorAll('.product-form__controls-group input[type="radio"]').forEach((radio) => {
      if (radio.disabled) return;
      const label = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      label?.querySelectorAll('.visually-hidden').forEach((message) => message.remove());
    });

    if (!document.querySelector('.mobile-purchase-assurance')) {
      buttonsContainer.insertAdjacentElement(
        'beforebegin',
        buildAssurance('mobile-purchase-assurance', 'mobile-purchase-assurance__item'),
      );
    }

    if (document.querySelector('.mobile-purchase-bar')) return;

    const bar = document.createElement('aside');
    bar.className = 'mobile-purchase-bar';
    bar.setAttribute('aria-label', originalButton.textContent.trim());

    const barPrice = document.createElement('div');
    barPrice.className = 'mobile-purchase-bar__price';

    const barButton = document.createElement('button');
    barButton.type = 'button';
    barButton.className = `${originalButton.className} mobile-purchase-bar__button`;

    bar.append(barPrice, barButton);
    document.body.append(bar);

    const sync = () => {
      const currentPrice = price.querySelector('.price-item--sale, .price-item--regular');
      barPrice.textContent = currentPrice?.textContent.trim() || price.textContent.trim();
      barButton.textContent = originalButton.textContent.trim();
      barButton.disabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
      barButton.setAttribute('aria-disabled', String(barButton.disabled));
    };

    sync();
    new MutationObserver(sync).observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
    new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });

    barButton.addEventListener('click', () => {
      if (barButton.disabled) return;
      originalButton.click();
    });
  };

  const initCartJourney = () => {
    if (!document.body.classList.contains('template-cart')) return;

    const checkoutButton = document.querySelector('[name="checkout"], button[type="submit"][name="checkout"]');
    if (!checkoutButton || document.querySelector('.mobile-cart-assurance')) return;

    checkoutButton.insertAdjacentElement(
      'beforebegin',
      buildAssurance('mobile-cart-assurance', 'mobile-cart-assurance__item'),
    );
  };

  const init = () => {
    if (!mobileQuery.matches) return;
    initCollectionDescription();
    initMobileSearch();
    initProductJourney();
    initCartJourney();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
